<template>
  <div>
    <p v-translate>You are about to recall/revoke/delete this submission. Another report will need to be submitted.</p>
    <p v-translate>Press OK to continue.</p>
  </div>
</template>

<script>

export default {
  data() {
    return {
    }
  }
}
</script>

